
import React, { useEffect } from 'react';
import { toast } from 'react-hot-toast';
import { parseMultipleOrdersText, parseBasicOrderText } from '../services/parserService';
import { Order, SystemConfig } from '../types';
import { Store } from 'lucide-react';

interface Props {
  onOrderParsed: (order: Order) => void;
  systemConfig: SystemConfig;
}

export const MagicPasteListener: React.FC<Props> = ({ onOrderParsed, systemConfig }) => {
  useEffect(() => {
    const handlePaste = async (e: ClipboardEvent) => {
      // Don't trigger if pasting into an input field
      if ((e.target as HTMLElement).tagName === 'INPUT' || (e.target as HTMLElement).tagName === 'TEXTAREA') {
        return;
      }

      const text = e.clipboardData?.getData('text');
      if (text) {
        // Try Batch Parse first
        try {
          const orders = parseMultipleOrdersText(text);
          if (orders.length > 0) {
             // Dispatch serially with a small delay to prevent browser freeze and geocoding rate limits
             for (const o of orders) {
                 onOrderParsed(o);
                 await new Promise(r => setTimeout(r, 150)); // 150ms buffer per order
             }
             
             if (orders.length === 1) {
                 toast.success('Pedido colado! Processando...');
             } else {
                 toast.success(`${orders.length} pedidos importados em lote!`);
             }
          } else {
             // Fallback for specific error messages (e.g., Pickup) via single parser
             try {
                 parseBasicOrderText(text);
                 toast.error('Formato não reconhecido.');
             } catch (err: any) {
                 if (err.message === 'PICKUP_DETECTED') {
                    toast('Retirada identificada. Pedido ignorado.', { 
                        icon: '✋',
                        style: {
                            background: '#FFF3CD',
                            color: '#856404',
                            border: '1px solid #FFEEBA',
                            fontWeight: 'bold'
                        }
                    });
                 } else {
                    toast.error('Falha no Magic Paste.');
                 }
             }
          }
        } catch (error) {
          console.error(error);
        }
      }
    };

    window.addEventListener('paste', handlePaste);
    return () => window.removeEventListener('paste', handlePaste);
  }, [onOrderParsed, systemConfig]);

  return null; // Invisible
};
